import { Routes, Route } from 'react-router-dom'
import { Layout } from '@/components/layout/Layout'
import { AuthCallback } from '@/components/auth/AuthCallback'
import { ProtectedRoute } from '@/components/auth/ProtectedRoute'
import { Dashboard } from '@/views/Dashboard'
import { Composers } from '@/views/Composers'
import { ComposerDetail } from '@/views/ComposerDetail'
import { Works } from '@/views/Works'
import { WorkDetail } from '@/views/WorkDetail'
import { Performers } from '@/views/Performers'
import { PerformerDetail } from '@/views/PerformerDetail'
import { Concerts } from '@/views/Concerts'
import { ConcertDetail } from '@/views/ConcertDetail'
import { Venues } from '@/views/Venues'
import { VenueDetail } from '@/views/VenueDetail'
import { Search } from '@/views/Search'
import { NotFound } from '@/views/NotFound'

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<Dashboard />} />
        <Route path="/composers" element={<Composers />} />
        <Route path="/composers/:id" element={<ComposerDetail />} />
        <Route path="/works" element={<Works />} />
        <Route path="/works/:id" element={<WorkDetail />} />
        <Route path="/performers" element={<Performers />} />
        <Route path="/performers/:id" element={<PerformerDetail />} />
        <Route path="/concerts" element={<Concerts />} />
        <Route path="/concerts/:id" element={<ConcertDetail />} />
        <Route path="/venues" element={<Venues />} />
        <Route path="/venues/:id" element={<VenueDetail />} />
        <Route path="/search" element={<Search />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  )
}
